import { useState, useEffect, useRef } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import "./empresasRegister.css";
import Header from "../../components/header/header";
import CustomModal from "../../components/modal/Modal";
import InputMask from "react-input-mask";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import {
  getCadastros,
  getUpdate,
  getEmpresaById,
} from "../../services/api_cadastros_empresas";
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import estados from "../../hooks/estados.json";
import Preview from "../../components/Preview/Preview";
import api from "../../services/api_refresh_token";

const EmpresasRegister = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.id;
  const [nome, setNome] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [inscricao_estadual, setInscEstadual] = useState("");
  const [cep, setCep] = useState("");
  const [endereco, setEndereco] = useState("");
  const [num_endereco, setNumEndereco] = useState("");
  const [bairro, setBairro] = useState("");
  const [cidade, setCidade] = useState("");
  const [uf, setUf] = useState("MG");
  const [anexo, setAnexo] = useState("");
  const [anexoToCompare, setAnexoToCompare] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [isSaving, setSaving] = useState(false)

  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});

  const inputRefs = {
    Endereco: useRef(null),
    Bairro: useRef(null),
    Cidade: useRef(null),
    Uf: useRef(null),
    Anexo: useRef(null),
  };

  useEffect(() => {
    const fetchEmpresa = async () => {
      try {
        setLoading(true);
        const response = await getEmpresaById(id);
        const empresa = response.data.empresa;
        setNome(empresa.nome || "");
        setCnpj(empresa.cnpj || "");
        setInscEstadual(empresa.inscricao_estadual || "");
        setCep(empresa.cep || "");
        setEndereco(empresa.endereco || "");
        setNumEndereco(empresa.num_endereco || "");
        setBairro(empresa.bairro || "");
        setCidade(empresa.cidade || "");
        setUf(empresa.estado || "");
        setAnexo(empresa.anexo || "");
        setAnexoToCompare(empresa.anexo || "");
        setLoading(false);
      } catch (error) {
        console.error("Erro ao obter dados da empresa:", error);
      }
    };

    if (id) {
      fetchEmpresa();
    }
  }, [id]);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = (title, body) => {
    setModalContent({ title, body });
    setShowModal(true);
  };

  const validarInputs = () => {
    if (!nome || !cnpj) {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O preenchimento dos campos Nome e CNPJ são obrigatórios.",
      });
      return false;
    }
    const filteredCNPJ = cnpj.replace(/\D/g, "");
    if (filteredCNPJ.length < 14) {
      Swal.fire({
        icon: "warning",
        title: "CNPJ inválido",
        text: "O CNPJ deve ter 14 dígitos.",
      });

      return false;
    }

    if (cep) {
      const filteredCep = cep.replace(/\D/g, "");
      if (filteredCep.length < 8) {
        Swal.fire({
          icon: "warning",
          title: "CEP inválido",
          text: "O CEP deve ter 8 dígitos.",
        });

        return false;
      }
    }
    return true;
  };

  const addCadastro = async (body) => {
    try {
      const response = await getCadastros(body, navigate, body.nome);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao cadastrar empresa:", response);
      }
    } catch (error) {
      console.error("Erro ao cadastrar empresa:", error);
    } finally {
    setSaving(false); // Desativa o spinner após o salvamento
  }
};

  const newUpdate = async (body) => {
    try {
      delete body.cnpj;
      const response = await getUpdate(id, body);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao atualizar registro:", response);
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        handleOpenModal(
          "Erro de validação",
          "Houve um erro na validação dos dados."
        );
      } else if (error.response && error.response.status === 500) {
        handleOpenModal(
          "Erro interno do servidor",
          "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde."
        );
      } else {
        console.error("Erro ao atualizar a empresa:", error);
        handleOpenModal(
          "Erro ao atualizar a empresa",
          "Por favor, tente novamente mais tarde."
        ); // Exibir mensagem genérica de erro
      }
    } finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const handleSalvar = () => {
    if (validarInputs()) {
      setSaving(true)
      let body = {
        nome,
        cnpj,
        inscricao_estadual,
        cep,
        endereco,
        num_endereco,
        bairro,
        cidade,
        estado: uf,
        anexo,
      };

      if (id) {
        anexoToCompare === anexo && delete body.anexo;
        newUpdate(body);
        setLoading(false);
      } else {
        addCadastro(body);
        setLoading(false);
      }
    }
  };

  const handleCaracteres = (e) => {
    const value = e.target.value;
    if (value.length <= 50) {
      setNome(value);
    } else {
      handleOpenModal(
        "Número de caracteres excedidos",
        "O Campo Nome não pode ultrapassar 50 caracteres"
      );
    }
  };

  const handleInscricaoEstadual = (e) => {
    const value = e.target.value;
    if (value.length <= 9) {
      setInscEstadual(value);
    } else {
      handleOpenModal(
        "Número de caracteres excedidos",
        "O Campo Número não pode ultrapassar 09 caracteres"
      );
    }
  };

  const handleEndereco = (e) => {
    const value = e.target.value;
    if (value.length <= 50) {
      setEndereco(value);
    } else {
      handleOpenModal(
        "Número de caracteres excedidos",
        "O Campo Número não pode ultrapassar 50 caracteres"
      );
    }
  };

  const handleNumero = (e) => {
    const value = e.target.value;
    if (value.length <= 50) {
      setNumEndereco(value);
    } else {
      handleOpenModal(
        "Número de caracteres excedidos",
        "O Campo Número não pode ultrapassar 50 caracteres"
      );
    }
  };

  const handleBairro = (e) => {
    const value = e.target.value;
    if (value.length <= 50) {
      setBairro(value);
    } else {
      handleOpenModal(
        "Número de caracteres excedidos",
        "O Campo Número não pode ultrapassar 50 caracteres"
      );
    }
  };

  const handleCidade = (e) => {
    const value = e.target.value;
    if (value.length <= 50) {
      setCidade(value);
    } else {
      handleOpenModal(
        "Número de caracteres excedidos",
        "O Campo Número não pode ultrapassar 50 caracteres"
      );
    }
  };

  const handleCep = async (e) => {
    const cep = e.replace(/\D/g, "");
    if (cep.length === 8) {
      try {
        const dadosCep = await api.get(`https://viacep.com.br/ws/${cep}/json/`);
        if (dadosCep.data.erro) {
          Swal.fire({
            icon: "warning",
            title: "CEP inválido",
            text: "Digite um CEP válido.",
          });
          setEndereco("");
          setBairro("");
          setCidade("");
          setUf("MG");
        } else {
          console.log(dadosCep.data);
          setEndereco(dadosCep.data.logradouro);
          setBairro(dadosCep.data.bairro);
          setCidade(dadosCep.data.localidade);
          setUf(dadosCep.data.uf);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleDeletePdf = () => {
    setAnexo("");
    document.getElementById("formAnexo").value = null;
  };

  const handleKeyDown = (e, nextFieldRef) => {
    if (e.key === 'Enter' && nextFieldRef.current) {
      e.preventDefault();
      const elementToFocus = nextFieldRef.current.inputRef || nextFieldRef.current;
  
      if (typeof elementToFocus.focus === 'function') {
        elementToFocus.focus();
      } else {
        console.warn('O elemento de input não tem o método focus.');
      }
    }
  };
  

  const regret = () => {
    window.history.back();
  };

  return (
    <>
      <Header title="Cadastros / Cadastro de empresa" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        {isLoading ? (
          <div className="center-btn">
            <h5 className="mb-5">Carregando dados</h5>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <Form className="mt-4">
            <Row>
              <Col md={6} className="mb-3">
                <Form.Group controlId="formNome">
                  <Form.Label>Nome</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite o nome"
                    value={nome}
                    onChange={handleCaracteres}
                    ref={inputRefs.Nome}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Endereco)}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6} className="mb-3">
                <Form.Group controlId="formCnpj">
                  <Form.Label>CNPJ</Form.Label>
                  <Form.Control
                    type="text"
                    as={InputMask}
                    placeholder="Digite o CNPJ"
                    mask="99.999.999/9999-99"
                    value={cnpj}
                    disabled={!!id}
                    onChange={(e) => setCnpj(e.target.value)}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={8} className="mb-3">
                <Form.Group controlId="formInscEstadual">
                  <Form.Label>Inscrição Estadual</Form.Label>
                  <Form.Control
                    type="text"
                    as={InputMask}
                    mask="999999999"
                    value={inscricao_estadual}
                    // disabled={!!id}
                    placeholder="Digite a inscrição estadual"
                    onChange={handleInscricaoEstadual}
                  />
                </Form.Group>
              </Col>
              <Col md={4} className="mb-3">
                <Form.Group controlId="formCep">
                  <Form.Label>CEP</Form.Label>
                  <Form.Control
                    type="text"
                    as={InputMask}
                    mask="99999-999"
                    value={cep}
                    placeholder="Digite o CEP"
                    onChange={(e) => setCep(e.target.value)}
                    onBlur={(e) => handleCep(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={9} className="mb-3">
                <Form.Group controlId="formEndereco">
                  <Form.Label>Endereço</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite o endereço"
                    value={endereco}
                    onChange={handleEndereco}
                    ref={inputRefs.Endereco}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Bairro)}
                  />
                </Form.Group>
              </Col>
              <Col md={3} className="mb-3">
                <Form.Group controlId="formNumero">
                  <Form.Label>Número</Form.Label>
                  <Form.Control
                    type="text"
                    as={InputMask}
                    mask="99999"
                    defaultValue={num_endereco}
                    placeholder="Digite o número"
                    onChange={handleNumero}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={5} className="mb-3">
                <Form.Group controlId="formBairro">
                  <Form.Label>Bairro</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite o bairro"
                    value={bairro}
                    onChange={handleBairro}
                    ref={inputRefs.Bairro}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Cidade)}
                  />
                </Form.Group>
              </Col>
              <Col md={5} className="mb-3">
                <Form.Group controlId="formCidade">
                  <Form.Label>Cidade</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite a cidade"
                    value={cidade}
                    onChange={handleCidade}
                    ref={inputRefs.Cidade}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Uf)}
                  />
                </Form.Group>
              </Col>
              <Col md={2} className="mb-3">
                <Form.Group controlId="formUF">
                  <Form.Label>U.F.</Form.Label>
                  <Form.Control
                    as="select"
                    value={uf}
                    onChange={(e) => setUf(e.target.value)}
                    ref={inputRefs.Uf}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Anexo)}
                  >
                    {estados.UF.map((estado) => (
                      <option value={estado.sigla}>{estado.sigla}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={4} className="mb-3">
                <Form.Group>
                  <Form.Label>Anexo:</Form.Label>
                  <Form.Control
                    id="formAnexo"
                    type="file"
                    accept="application/pdf"
                    value={anexo?.fileName}
                    onChange={(e) => setAnexo(e.target.files[0])}
                    ref={inputRefs.Anexo}
                    // onChange={(e) => setAnexo(e.target.files[0])}
                  />
                  {anexo && (
                    <Preview anexo={anexo} handleDelete={handleDeletePdf} />
                  )}
                </Form.Group>
              </Col>
            </Row>

            <div className="center-two-btn d-flex justify-content-center ">
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={handleSalvar}
                disabled = {isSaving}
              >
                {isSaving ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <FontAwesomeIcon icon={faSave} />
                )}
              </Button>
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={regret}
              >
                <FontAwesomeIcon icon={faWindowClose} />
              </Button>
            </div>
          </Form>
        )}
      </div>

      <CustomModal
        show={showModal}
        handleClose={handleCloseModal}
        title={modalContent.title}
        body={modalContent.body}
      />
    </>
  );
};

export default EmpresasRegister;
